export default function getFontFromVariant(variant: string, weight: string): string {
  const fonts = {
    normal: variant === 'base' ? 'Graphik' : 'SourceCodePro-Regular',
    medium: variant === 'base' ? 'Graphik' : 'SourceCodePro-Medium',
    default: variant === 'base' ? 'Graphik' : 'SourceCodePro-Semibold'
  };

  return fonts[weight] || fonts.default;
}
